import { render, staticRenderFns } from "./EnumDisplay.vue?vue&type=template&id=2050a1c5&"
import script from "./EnumDisplay.vue?vue&type=script&lang=js&"
export * from "./EnumDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports